import { useContext } from "react";
import { Box, Stack, Typography } from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";

import "../../../Style/pagestyle.scss";
import { AuthContext } from "../../../Context/AuthContext";
import ScheduleAction from "./ScheduleAction";

const ScheduleCard = ({ editData, day, mainId, classData, setRefetch }) => {
  const { language, t } = useContext(AuthContext);

  const subjectName =
    language === "en"
      ? editData?.subjectId?.enName
      : editData?.subjectId?.khName;

  const timeRange = `${editData?.startTime} - ${editData?.endTime}`;

  return (
    <Box
      className="schedule-card"
      sx={{
        p: 2,
        bgcolor: "white",
        position: "relative",
      }}
    >
      {/* Top-right Action Menu */}
      <Box sx={{ position: "absolute", top: 8, right: 12 }}>
        <ScheduleAction
          day={day}
          mainId={mainId}
          editData={editData}
          classData={classData}
          setRefetch={setRefetch}
        />
      </Box>

      {/* Subject & Time */}
      <Stack spacing={0.5} mt={1.5} mb={0.75} alignItems="flex-start">
        {/* Subject Row */}
        <Stack direction="row" spacing={1} alignItems="center">
          <MenuBookIcon fontSize="small" sx={{ color: "#40748E" }} />
          <Typography
            sx={{
              fontWeight: "bold",
              color: "#131870",
            }}
          >
            {subjectName}
          </Typography>
        </Stack>

        {/* Time Row */}
        <Stack direction="row" spacing={1} alignItems="center">
          <AccessAlarmIcon fontSize="small" sx={{ color: "#E7873D" }} />
          <Typography sx={{ color: "gray", fontSize: 15 }}>
            {timeRange}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default ScheduleCard;
